// extracted by mini-css-extract-plugin
export var elevatedFrame = "_4-2";
export var elevatedShell = "_4-1";
export var shell = "_4-0";